import * as E from 'fp-ts/lib/Either';
import * as t from 'io-ts';

/*
 * Types.
 */

export interface ApiType<T extends t.Mixed> {
  name: string;
  runtimeType: T;
  parse(src: any): t.TypeOf<T>;
}

/*
 * Builder.
 */

export function makeApiType<T extends t.Mixed>(
  name: string,
  runtimeType: T,
  parse: (src: any) => t.TypeOf<T>,
): ApiType<T> {
  return {
    name,
    runtimeType,
    parse,
  };
}

/*
 * Parser.
 */

export function readApiModel<T extends t.Type<any>>(apiType: ApiType<T>, src: any): t.TypeOf<T> {
  // Parse the object.
  const modelParsed = apiType.parse(src);

  // Validate it.
  const modelValidated = apiType.runtimeType.decode(modelParsed);
  return ensureValidApiModel(apiType, modelValidated);
}

function ensureValidApiModel<T extends t.Type<any>>(
  apiType: ApiType<T>,
  modelValidated: E.Either<t.Errors, any>,
) {
  if (!E.isRight(modelValidated)) {
    throw new Error(`[io-ts] Unable to parse ${apiType.name}.`);
  }

  return modelValidated.right;
}
